$(document).ready(function () {
  $('.marquee-alert').marquee({
    direction: 'left',
    duration: 40000,
    delayBeforeStart: 0,
    duplicated: true,
    gap: 0,
    startVisible: true
  });
  
  $(".slide-list").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    arrows: false,
  });

  $(".icon_with_text_inner").slick({
    dots: false,
    arrows: true,
    infinite: true,
    centermode: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1640,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".customer_list").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(document).on("click", ".accordion details", function (e) {
    e.preventDefault();
    if ($(this).attr("open")) {
      $(this).attr("open", false);
    } else {
      $(".accordion details").attr("open", false);
      $(this).attr("open", true);
    }
  });

  $(document).on("click", "#trustshop-review--summary", function () {
    $('ul.tabs li[rel="tab3"]').trigger("click");
    $("html, body").animate(
      {
        scrollTop: $("#tab3").offset().top,
      },
      1000
    );
  });

  // random number on PDP

  // Object to store random numbers for each variant
  // const randomNumbers = {
  //     Orange: null,
  //     Coffee: null
  // };

  // // Load and validate stored values from localStorage
  // const loadStoredNumbers = () => {
  //     const variants = ['Orange', 'Coffee'];
  //     const expirationTime = 30 * 60 * 1000; // 30 minutes in milliseconds

  //     variants.forEach(variant => {
  //       console.log(variant)
  //         const storedData = localStorage.getItem(`randomNumber_${variant}`);
  //         if (storedData) {
  //             const {
  //                 number,
  //                 timestamp
  //             } = JSON.parse(storedData);
  //             const currentTime = new Date().getTime();

  //             // Check if 30 minutes have passed
  //             if (currentTime - timestamp < expirationTime) {
  //                 randomNumbers[variant] = number;
  //             } else {
  //                 // Remove expired value
  //                 localStorage.removeItem(`randomNumber_${variant}`);
  //             }
  //         }
  //     });
  // };

  // const updateRandomNumber = (variant) => {
  //     const currentHour = new Date().getHours();
  //     const timeSlotData = $("#time-slot-data");
  //     const slot1Range = timeSlotData.data("slot-1-range").split("-");
  //     const slot2Range = timeSlotData.data("slot-2-range").split("-");

  //     const slot1Min = parseInt(slot1Range[0], 10);
  //     const slot1Max = parseInt(slot1Range[1], 10);
  //     const slot2Min = parseInt(slot2Range[0], 10);
  //     const slot2Max = parseInt(slot2Range[1], 10);

  //     let min, max;
  //     if (currentHour >= 9 && currentHour < 24) {
  //         min = slot1Min;
  //         max = slot1Max;
  //     } else {
  //         min = slot2Min;
  //         max = slot2Max;
  //     }

  //     let numberToShow = randomNumbers[variant];
  //     if (numberToShow === null) {
  //         // Generate new number and store with timestamp
  //         numberToShow = Math.floor(Math.random() * (max - min + 1)) + min;
  //         randomNumbers[variant] = numberToShow;
  //         console.log(numberToShow)
  //         const dataToStore = {
  //             number: numberToShow,
  //             timestamp: new Date().getTime()
  //         };
  //         localStorage.setItem(`randomNumber_${variant}`, JSON.stringify(dataToStore));
  //     }
  //     console.log(numberToShow)

  //     $("#random-number").text(numberToShow);
  // };

  // // Initialize on page load
  // loadStoredNumbers();

  // // // Set initial values for Orange
  // // $("#time-slot-data").attr('data-slot-1-range', '40-50');
  // // $("#time-slot-data").attr('data-slot-2-range', '10-20');

  // const defaultVariant = 'Orange';
  // updateRandomNumber(defaultVariant);

  // $(document).on("click", '.swatch-input__label', function() {
  //     const selectedVariantInput = $(this).prev('input');
  //     const isUnavailable = selectedVariantInput.hasClass('visually-disabled');

  //     if (isUnavailable) {
  //         //$("#random-number").text(0);
  //         $("#cart-message").hide();
  //     } else {
  //         $("#cart-message").show();
  //         const selectedVariant = selectedVariantInput.val();

  //         const selectedTimeSlot1 = getTimeSlotForVariant(selectedVariant, 1);
  //         const selectedTimeSlot2 = getTimeSlotForVariant(selectedVariant, 2);

  //         $("#time-slot-data").attr('data-slot-1-range', selectedTimeSlot1);
  //         $("#time-slot-data").attr('data-slot-2-range', selectedTimeSlot2);

  //         updateRandomNumber(selectedVariant);
  //     }
  // });

  // function getTimeSlotForVariant(variantId, slotNumber) {
  //     if (variantId === 'Orange') {
  //         return slotNumber === 1 ? '40-50' : '10-20';
  //     } else if (variantId === 'Coffee') {
  //         return slotNumber === 1 ? '50-60' : '20-30';
  //     }
  //     return '0-0';
  // }


  const randomNumbers = {
    Default: null,
    Orange: null,
    Coffee: null
};

// Load and validate stored values from localStorage
const loadStoredNumbers = () => {
    const variants = Object.keys(randomNumbers);
    const expirationTime = 30 * 60 * 1000; // 30 minutes

    variants.forEach(variant => {
        const storedData = localStorage.getItem(`randomNumber_${variant}`);
        if (storedData) {
            const { number, timestamp } = JSON.parse(storedData);
            const currentTime = new Date().toLocaleString("en-US", { timeZone: "America/New_York" });
            if (currentTime - timestamp < expirationTime) {
                randomNumbers[variant] = number;
            } else {
                localStorage.removeItem(`randomNumber_${variant}`);
            }
        }
    });
};

const updateRandomNumber = (variant, selectedTimeSlot1 = null, selectedTimeSlot2 = null, showATCMsg = false) => {
  //const currentHour = new Date().getHours();
  const currentHourET = new Date().toLocaleString("en-US", { timeZone: "America/New_York" });
  const currentHour = new Date(currentHourET).getHours();

  let timeSlotDatas = $("#time-slot-data");
  let slot1Range = timeSlotDatas.data("slot-1-range").split("-");
  let slot2Range = timeSlotDatas.data("slot-2-range").split("-");
  
  if(!showATCMsg) {
    var slot1Min = parseInt(slot1Range[0], 10);
    var slot1Max = parseInt(slot1Range[1], 10);
    var slot2Min = parseInt(slot2Range[0], 10);
    var slot2Max = parseInt(slot2Range[1], 10);
    // IF EITHER is empty → hide cart-message and stop
    if (!slot1Range || !slot2Range || slot1Range.includes("") || slot2Range.includes("")) {
      console.log('EITHER is empty ');

      document.getElementById("cart-message").classList.add("hidden");
      return ;
    } else {
      document.getElementById("cart-message").classList.remove("hidden");
    }
  } else {
    let slot1Range = selectedTimeSlot1.split("-");
    let slot2Range = selectedTimeSlot2.split("-");
    
    // Extract numbers using regex (works with any separator)
    let slot1Numbers = selectedTimeSlot1.match(/\d+/g);
    let slot2Numbers = selectedTimeSlot2.match(/\d+/g);

    var slot1Min = parseInt(slot1Numbers[0], 10);
    var slot1Max = parseInt(slot1Numbers[1], 10);
    var slot2Min = parseInt(slot2Numbers[0], 10);
    var slot2Max = parseInt(slot2Numbers[1], 10);
  }
  
  let min, max;
  if (currentHour >= 9 && currentHour < 24) {
      min = slot1Min;
      max = slot1Max;
  } else {
      min = slot2Min;
      max = slot2Max;
  }

  let numberToShow = randomNumbers[variant];
  
  if (numberToShow === null) {
    numberToShow = Math.floor(Math.random() * (max - min + 1)) + min;

    randomNumbers[variant] = numberToShow;

    const dataToStore = {
        number: numberToShow,
        timestamp: Date.now()
    };
    localStorage.setItem(`randomNumber_${variant}`, JSON.stringify(dataToStore));
  }
  $("#random-number").text(numberToShow);
};

// Initialize on page load
loadStoredNumbers();

// Default time slot ranges
// $("#time-slot-data").attr('data-slot-1-range', '30-40'); // example values
// $("#time-slot-data").attr('data-slot-2-range', '5-15');  // example values

// Always start with Default variant
const timeSlotContainer = $("#time-slot-data");
if(timeSlotContainer) {
  const defaultVariantTitle = timeSlotContainer.data("default-variant-title");
  // const defaultVariantTitle = "Default";
  updateRandomNumber(defaultVariantTitle);
}


// Handle variant clicks
// $(document).on("click", '.swatch-input__label', function() {
$(document).on("click", 'fieldset.js.product-form__input label', function(e) {
  const selectedVariantInput = $(this).prev('input');
  const isUnavailable = selectedVariantInput.hasClass('visually-disabled');

  if (isUnavailable) {
    $("#cart-message").hide();
  } else {
    $("#cart-message").show();
    const selectedVariant = selectedVariantInput.val();

    let selectedTimeSlot1 = getTimeSlotForVariant(selectedVariant, 1);
    let selectedTimeSlot2 = getTimeSlotForVariant(selectedVariant, 2);
    
    selectedTimeSlot1 = selectedTimeSlot1 || '0-0';
    selectedTimeSlot2 = selectedTimeSlot2 || '0-0';

    $("#time-slot-data").attr('data-slot-1-range', selectedTimeSlot1);
    $("#time-slot-data").attr('data-slot-2-range', selectedTimeSlot2);
    // Check if either is "0-0"
    if (selectedTimeSlot1 === '0-0' || selectedTimeSlot2 === '0-0') {
      $("#cart-message").hide();

      return;
    } else {
      console.log('show atc msg')
      document.getElementById("cart-message").classList.remove("hidden");
      $("#cart-message").show();
      updateRandomNumber(selectedVariant, selectedTimeSlot1, selectedTimeSlot2, showATCMsg = true);
    }
  }
});

function getTimeSlotForVariant(variantId, slotNumber) {
  const normalizedId = normalize(variantId);
  // Find matching element of time slots (FULLY FIXED)
  const timeSlotData = Array.from(document.querySelectorAll('.time-slot-data'))
    .find(el => normalize(el.dataset.variantTitle) === normalizedId);

  // -------- DEFAULT LOGIC BLOCK --------
  if (normalizedId === "default") {
    if (timeSlotData) {
      const slot1Range = timeSlotData.dataset.slotOneRange;
      const slot2Range = timeSlotData.dataset.slotTwoRange;
      return slotNumber === 1 ? slot1Range : slot2Range;
    }
    return "0-0";
  }

  // If nothing matched
  if (!timeSlotData) {
    console.warn(`No time-slot-data found for variant: ${variantId}`);
    return "0-0";
  }
  // Extract ranges
  const slot1Range = timeSlotData.dataset.slotOneRange;
  const slot2Range = timeSlotData.dataset.slotTwoRange;
  return slotNumber === 1 ? slot1Range : slot2Range;
}
// Normalizer
function normalize(str) {
  return str
    .toString()
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ""); 
}

  // random number on PDP
});

// tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$(".tab-container").each(function (k, v) {
  $(v).find(".tab_content:first").show();
});

/* if in tab mode */
$("ul.tabs li").click(function () {
  var parent = $(this).parents(".tab-container");

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent)
    .find("#" + activeTab)
    .fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent)
    .find(".tab_drawer_heading[rel^='" + activeTab + "']")
    .addClass("d_active");
});
/* if in drawer mode */
$(".tab_drawer_heading").click(function () {
  var parent = $(this).parents(".tab-container");

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent)
    .find("#" + d_activeTab)
    .fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent)
    .find("ul.tabs li[rel^='" + d_activeTab + "']")
    .addClass("active");
});

/* Extra class "tab_last"
   to add border to right side
   of last tab */
$("ul.tabs li").last().addClass("tab_last");

//


$(document).ready(function () {
  $('.product-card-wrapper').each(function () {
    const productCard = $(this);
    const productUrl = productCard.find('a.full-unstyled-link').attr('href');
    if (!productUrl) return;

    const productHandle = productUrl.split('/products/')[1]?.split('?')[0];
    if (!productHandle) return;

    $.getJSON('/products/' + productHandle + '.js', function (product) {
      const options = product.options;
      const variants = product.variants;

      const swatchForm = $('<form class="variant-swatches"></form>');
      const selectedOptions = Array(options.length).fill(null);

    options.forEach((option, optionIndex) => {
      const values = [...new Set(variants.map(v => v.options[optionIndex]))];
    
      if (values.length === 1 && values[0] === 'Default Title') return;
    
      const optionGroup = $(`<div class="option-group" data-option-index="${optionIndex}">
        <div class="flex flex-wrap gap-2"></div>
      </div>`);
       // <div class="text-sm font-medium mb-1">${option.name}:</div>

        const colorMap = {
          "Red": "rgb(255, 0, 0)",
          "Blue": "rgb(0, 0, 255)",
          "Green": "rgb(0, 128, 0)",
          "Black": "rgb(0, 0, 0)",
          "White": "rgb(255, 255, 255)",
          "Yellow": "rgb(255, 255, 0)",
          "Purple": "rgb(128, 0, 128)",
          "Pink": "rgb(255, 192, 203)",
          "Orange": "rgb(255, 165, 0)",
          "Gray": "rgb(128, 128, 128)",
          "Coffee": "rgb(99, 72, 50)",
        };
      
        values.forEach((value, i) => {
          const id = `opt-${product.id}-${optionIndex}-${i}`;
          const variantForValue = variants.find(v => v.options[optionIndex] === value);
          const variantImg = variantForValue?.featured_image?.src;
          const rgbColor = colorMap[value] || value.toLowerCase();

          const input = $(`
            <label class="label-custom-qe" title="${value}">
              <input type="radio" name="opt-${product.id}-${optionIndex}" id="${id}" value="${value}" class="input-qe">
                <span class="variant-span-qe" style="
                  background-color: ${rgbColor};
                  background-size: contain;
                  background-position: center;
                  background-repeat: no-repeat;
                  background-blend-mode: multiply;
                "></span>
            </label>
          `);

          input.find('input').on('change', function () {
            selectedOptions[optionIndex] = value;

            const matchedVariant = variants.find(v =>
              v.options.every((optVal, idx) => selectedOptions[idx] === optVal)
            );

            if (matchedVariant) {
              const img = productCard.find('img.motion-reduce');
              const variantImg = matchedVariant.featured_image?.src || product.images[0];
              img.attr('src', variantImg).attr('srcset', '');

              const priceWrapper = productCard.find('.price-item--sale');
              const priceWrapperCompare = productCard.find('.price-item--regular');
              
              const money = (matchedVariant.price / 100).toFixed(2);
              const compateMoney = (matchedVariant.compare_at_price / 100).toFixed(2);
              
              priceWrapper.text(`$${money}`);
              priceWrapperCompare.text(`$${compateMoney}`);
              
            }
          });

          optionGroup.find('div.flex').append(input);
        });

        swatchForm.append(optionGroup);
      });

      productCard.find('.collection-swatches').html(swatchForm);
    });
  });
});
